import ToolPlayControllerContext from './context';

const useToolPlayControllerContext = () => ToolPlayControllerContext.hook();

export default useToolPlayControllerContext;
